import { profile, contacts } from "../data/profile";
import { projects } from "../data/projects";
import { asset } from "../lib/asset";
import { experienceLabel } from "../lib/experience";
import { useCurrentDate } from "../hooks/useCurrentDate";
import { useI18n } from "../i18n/LanguageContext";
import { Icon } from "./Icon";
import styles from "./Hero.module.css";

const githubHref =
  contacts.find((c) => c.icon === "github")?.href ??
  "https://github.com/LordDarthArt";
const emailHref =
  contacts.find((c) => c.icon === "email")?.href ?? "#contact";

export function Hero() {
  const { t, ui } = useI18n();

  const now = useCurrentDate();
  const years = experienceLabel(profile.careerStart, now);
  const tagline = t(profile.tagline).replace("{years}", years);

  const stats = [
    { value: years, label: ui.hero.stats.years },
    { value: profile.commercialProjects, label: ui.hero.stats.commercial },
    { value: `${projects.length}`, label: ui.hero.stats.featured },
  ];

  return (
    <section id="home" className={styles.hero}>
      <div
        className={styles.bg}
        style={{ backgroundImage: `url(${asset("images/background.png")})` }}
        aria-hidden="true"
      />
      <div className={styles.glow} aria-hidden="true" />

      <div className={`container ${styles.inner}`}>
        <p className={styles.eyebrow}>
          <Icon name="sparkles" size={16} />
          {t(profile.role)}
        </p>

        <h1 className={styles.name}>{t(profile.name)}</h1>

        <p className={styles.tagline}>{tagline}</p>

        <div className={styles.skills}>
          {t(profile.skills).map((skill) => (
            <span key={skill} className="chip">
              {skill}
            </span>
          ))}
        </div>

        <div className={styles.actions}>
          <a href="#work" className="btn btn--primary">
            <Icon name="code" size={18} />
            {ui.hero.viewWork}
          </a>
          <a href={githubHref} target="_blank" rel="noreferrer" className="btn">
            <Icon name="github" size={18} />
            {ui.hero.github}
          </a>
          <a href={emailHref} className="btn btn--ghost">
            <Icon name="email" size={18} />
            {ui.hero.contact}
          </a>
        </div>

        <dl className={styles.stats}>
          {stats.map((stat) => (
            <div key={stat.label} className={styles.stat}>
              <dt className={styles.statValue}>{stat.value}</dt>
              <dd className={styles.statLabel}>{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <a href="#work" className={styles.scrollHint} aria-label={ui.hero.viewWork}>
        <span />
      </a>
    </section>
  );
}
